// The default workspace's subdomain (see back/scripts/migrate-default-
// workspace.ts and the design spec §5.1). It is the fallback for
// server-side call sites that need a workspace but cannot resolve one from
// the request - e.g. `pages/tutorial.tsx`'s build-time getStaticProps, and
// the NextAuth `authorize()` host fallback in
// `pages/api/auth/[...nextauth].ts`.
// It is NOT where the root domain points: the bare root domain now serves
// the public marketing site and `www.<root>` 301-redirects to it (see
// `front/middleware.ts`).
export const DEFAULT_WORKSPACE_SUBDOMAIN = "app"

export type WorkspaceHostResolution =
  | { kind: "workspace"; subdomain: string }
  | { kind: "marketing" }
  | { kind: "not-found" }

export function resolveWorkspaceHost(
  host: string,
  rootDomain: string
): WorkspaceHostResolution {
  const hostWithoutPort = host.split(":")[0]

  if (hostWithoutPort === rootDomain || hostWithoutPort === `www.${rootDomain}`) {
    return { kind: "marketing" }
  }

  const suffix = `.${rootDomain}`
  if (!hostWithoutPort.endsWith(suffix)) {
    return { kind: "not-found" }
  }

  const subdomain = hostWithoutPort.slice(0, -suffix.length)

  if (!subdomain || subdomain.includes(".")) {
    return { kind: "not-found" }
  }

  return { kind: "workspace", subdomain }
}
